<template>
  <div>
    <van-tabbar v-if="show && index == 1" v-model="active" style="z-index:10" active-color="#2f80ed" :border="true" inactive-color="#979799">
      <van-tabbar-item v-for="(k, key) in item" replace :to="k.router" :key="key">
          <span>{{ $t(k.title) }}</span>
          <template #icon="props">
            <img :src="props.active ? k.icon.active : k.icon.noactive" :alt="k.title"  />
          </template>
      </van-tabbar-item>
    </van-tabbar>

    <van-tabbar v-if="show && index == 2" v-model="active" style="z-index:10" active-color="#2f80ed" :border="true" inactive-color="#979799">
      <van-tabbar-item v-for="(k, key) in item1" replace :to="k.router" :key="key">
        <span>{{ $t(k.title) }}</span>
        <template #icon="props">
          <img v-if="key != 2" :src="props.active ? k.icon.active : k.icon.noactive" :alt="k.title"  />
          <img v-else :src="props.active ? k.icon.active : k.icon.noactive" :alt="k.title" style="height: 70px;margin-top: -40px" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
	data() {
		return {
			show: false,
      index: 0,
			active: "",
      item1:[
        {
          router: '/home',
          title: "家",
          index: 2,
          icon: {
            active: '/img/footer/indexed.png',
            noactive: '/img/footer/index.png'
          }
        },
        {
          router: '/GameRecord',
          title: "订单",
          index: 2,
          icon: {
            active: '/img/footer/ordered.png',
            noactive: '/img/footer/order.png'
          }
        },
        {
          router: '/game',
          title: "",
          index: 2,
          icon: {
            active: '/img/footer/grab.png',
            noactive: '/img/footer/grab.png'
          }
        },
        {
          router: '/ServicePage',
          title: "mine.service",
          index: 2,
          icon: {
            active: '/img/footer/serviceed.png',
            noactive: '/img/footer/service.png'
          }
        },
        {
          router: '/mine',
          title: "用户",
          index: 2,
          icon: {
            active: '/img/footer/mineed.png',
            noactive: '/img/footer/mine.png'
          }
        }
      ],
			item: [
				{
					router: '/loginChoose',
					title: "footer.home",
          index: 1,
					icon: {
						active: '/img/footer/loginChooseed.jpeg',
						noactive: '/img/footer/loginChoose.jpeg'
					}
				},
				{
					router: '/loginHome',
					title: "畅销书",
          index: 1,
					icon: {
						active: '/img/footer/loginHomeed.jpeg',
						noactive: '/img/footer/loginHome.jpeg'
					}
				},
				{
					router: '/loginPrice',
					title: "共享购物",
          index: 1,
					icon: {
						active: '/img/footer/loginPriceed.jpeg',
						noactive: '/img/footer/loginPrice.jpeg'
					}
				},
        {
          router: '/login',
          title: "会员页面",
          index: 1,
          icon: {
            active: '/img/footer/index.jpeg',
            noactive: '/img/footer/index.jpeg'
          }
        },

			]
		};
	},
	methods: {
    /*texts(){
      this.item[0].title = this.$t("footer.home");
      this.item[1].title = this.$t("畅销书");
      this.item[2].title = this.$t("共享购物");
      this.item[3].title = this.$t("会员页面");
    }*/
  },
	watch: {
		$route(to) {
			if (to.name == 'loginChoose') {
				this.active = 0;
        this.index = 1;
				this.show = true;
			} else if (to.name == 'loginHome') {
				this.active = 1;
        this.index = 1;
				this.show = true;
			} else if (to.name == 'loginPrice') {
				this.active = 2;
        this.index = 1;
				this.show = true;
			}else if (to.name == 'home') {
        this.active = 0;
        this.index = 2;
        this.show = true;
      }else if (to.name == 'GameRecord') {
        this.active = 1;
        this.index = 2;
        this.show = true;
      }else if (to.name == 'game') {
        this.active = 2;
        this.index = 2;
        this.show = true;
      }else if (to.name == 'ServicePage') {
        this.active = 3;
        this.index = 2;
        this.show = true;
      }else if (to.name == 'mine') {
        this.active = 4;
        this.index = 2;
        this.show = true;
      }else if (to.name == 'Grab') {
        this.active = 2;
        this.index = 2;
        this.show = true;
      }  else {
				this.show = false;
        this.index = 0;
			}
      //this.texts();
		}
	},
	created() {
    //this.texts();
    if (this.$route.name  == 'loginChoose') {
      this.active = 0;
      this.index = 1;
      this.show = true;
    } else if (this.$route.name  == 'loginHome') {
      this.active = 1;
      this.index = 1;
      this.show = true;
    } else if (this.$route.name  == 'loginPrice') {
      this.active = 2;
      this.index = 1;
      this.show = true;
    }else if (this.$route.name  == 'index') {
      this.active = 3;
      this.index = 1;
      this.show = true;
    }else if (this.$route.name == 'home') {
      this.active = 0;
      this.index = 2;
      this.show = true;
    }else if (this.$route.name == 'GameRecord') {
      this.active = 1;
      this.index = 2;
      this.show = true;
    }else if (this.$route.name == 'game') {
      this.active = 2;
      this.index = 2;
      this.show = true;
    }else if (this.$route.name == 'ServicePage') {
      this.active = 3;
      this.index = 2;
      this.show = true;
    }else if (this.$route.name == 'mine') {
      this.active = 4;
      this.index = 2;
      this.show = true;
    }else if (this.$route.name == 'Grab') {
      this.active = 2;
      this.index = 2;
      this.show = true;
    } else {
      this.show = false;
      this.index = 0;
    }

	}
};
</script>

<style lang="less" scoped>
@tabbar-height: 110px;
@tabbar-img: 55px;
.van-tabbar {
	height: @tabbar-height;
}
.van-tabbar-item__icon img {
	height: @tabbar-img;
}
.van-tabbar-item {
	font-size: 26px;
}
.tui {
	width: 4rem;
	margin-top: -10.333vw;
	background-color: white;
	border-radius: 50%;
	border: 10px solid white;
	z-index: 10;
}
[class*='van-hairline']::after {
	border: none !important;
}
::v-deep .van-tabbar-item__text{
  text-align: center;
}
</style>
